class KlaviyoPopup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  handleTrigger () {
    window._klOnsite = window._klOnsite || []
    window._klOnsite.push(['openForm', this.dataset.klaviyoFormId])
  }
}

if (!customElements.get('klaviyo-popup')) {
  customElements.define('klaviyo-popup', KlaviyoPopup)
}
